// Author YuJiaBei
// Date 2021-04-05 12:08:25

class SithMesPrdPpOperationDependencyPod {
constructor({
        id = null,
        podIdOrigin = '',
        originOrderCode = '',
        originOperationSeq = '',
        podIdTarget = '',
        targetOrderCode = '',
        targetOperationSeq = '',
        podType = '',
        podLagTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.podIdOrigin = podIdOrigin;
    this.originOrderCode = originOrderCode;
    this.originOperationSeq = originOperationSeq;
    this.podIdTarget = podIdTarget;
    this.targetOrderCode = targetOrderCode;
    this.targetOperationSeq = targetOperationSeq;
    this.podType = podType;
    this.podLagTime = podLagTime;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpOperationDependencyPod();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'podIdOrigin',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.podIdOrigin',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'originOrderCode',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.originOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'originOperationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.originOperationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'podIdTarget',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.podIdTarget',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetOrderCode',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.targetOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetOperationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.targetOperationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'podType',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.podType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'podLagTime',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.podLagTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    podIdOriginFilter : "",
    originOrderCodeFilter : "",
    originOperationSeqFilter : "",
    podIdTargetFilter : "",
    targetOrderCodeFilter : "",
    targetOperationSeqFilter : "",
    podTypeFilter : "",
    podLagTimeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'podIdOriginFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.podIdOrigin',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'originOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.originOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'originOperationSeqFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.originOperationSeq',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'podIdTargetFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.podIdTarget',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'targetOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.targetOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetOperationSeqFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.targetOperationSeq',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'podTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.podType',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'podLagTimeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.filter.podLagTime',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'podIdOrigin',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.podIdOrigin',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'originOrderCode',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.originOrderCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'originOperationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.originOperationSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"podIdOrigin":"id","originOrderCode":"orderCode"}'
                }
        },
        {
        key: 'podIdTarget',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.podIdTarget',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetOrderCode',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.targetOrderCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetOperationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.targetOperationSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"podIdTarget":"id","targetOrderCode":"orderCode"}'
                }
        },
        {
        key: 'podType',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.podType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '完成开始' },
                { value: '2', text: '开始开始' },
                { value: '3', text: '完成完成' },
                { value: '4', text: '开始完成' }
            ]
        }
        },
        {
        key: 'podLagTime',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.podLagTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpOperationDependencyPod.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpOperationDependencyPod, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
